const defaultState = {
  loggingIn: false,
  userid: "",
  username: "",
  domainid: "",
  domainname: "",
  accesslevel: "",
}

const getters = {
  userid(state) {
    return state.userid;
  },
  username(state) {
    return state.username;
  },
  domainid(state) {
    return state.domainid;
  },
  domainname(state) {
    return state.domainname;
  },
  isLoggingIn(state) {
    return state.loggingIn;
  },
  accesslevel(state) {
    return state.accesslevel;
  }
}

const actions = {
  login({ commit }, { userid, username, domainid, domainname, accesslevel }) {
    commit('login', { userid, username, domainid, domainname, accesslevel })
  },
  logout({ commit }) {
    commit('logout')
  }
}

const mutations = {
  login(state, { userid, username, domainid, domainname, accesslevel }) {
    state.userid = userid;
    state.username = username;
    state.domainid = domainid;
    state.domainname = domainname;
    state.loggingIn = true;
    state.accesslevel = accesslevel;
  },
  logout(state) {
    Object.assign(state, defaultState)
  }
}

export default {
  namespaced: true,
  state: JSON.parse(JSON.stringify(defaultState)),
  getters,
  actions,
  mutations
}